import themeFactory from './themes/factory'
import { formatTime } from 'amkit3-modules/utils/utils'

class ContinuousBar {
  constructor($, $container, options, core) {
    this.$ = $
    this.$container = $container
    this.options = options
    this.core = core
    this.style = themeFactory.getStyle()
    this.selector = themeFactory.getSelector()

    this.$bar = this.$container.find(this.selector.continuousBar)
    this.$titleLink = this.$container.find(this.selector.continuousBarTitleLink)

    this.$container.on('click', this.selector.continuousBarCloseButton, evt => {
      this.$bar.css('display', 'none')
    })
    // 获取上次播放进度
    const lastPlayTime = this.core.getLastPlayTime()
    if (lastPlayTime >= 5) {
      this.$container.find(this.selector.time).text(formatTime(lastPlayTime))
    } else {
      this.$bar.css('display', 'none')
    }
    // 从头播放
    this.$container.on('click', this.selector.btn, evt => {
      this.core.recordPlayTime()
      this.core.seek(0)
      // 隐藏提示条
      this.$bar.css('display', 'none')
    })
    setTimeout(() => {
      this.$bar.css('display', 'none')
    }, 5000)
  }
  show(title, link) {
    this.$titleLink.text(title)
    this.$titleLink.prop('href', link)
    this.$bar.css('visibility', 'visible')
  }
}

export default ContinuousBar
